/**
 * Remove visibility rules from a specified field
 * @param {import('./types').EcrionFormState} state
 * @param {string} fieldId
 */
var removeVisibility = function removeVisibility(state, fieldId) {
  if (!state.visibility.conditions[fieldId]) return;
  state.visibility.conditions[fieldId].forEach(function (condition) {
    if (!state.visibility.mapping[condition.field]) return;
    state.visibility.mapping[condition.field].remove(fieldId);
  });
  delete state.visibility.conditions[fieldId];
};
/**
 * Read visibility rules from the fields
 * @param {import('./types').EcrionFormState} state
 * @param {import('./types').EcrionFormField} field
 * @param {number} value
 */


var readVisibility = function readVisibility(state, field, value) {
  if (!field.visibility) return;
  var fieldId = field.id + "_".concat(value);

  try {
    /** @type {Array<import('./types').VisibilityCondition>} */
    var visibilityConditions = JSON.parse(field.visibility); // for each condition, check if we need to update field id to correspond with the repeating

    visibilityConditions.forEach(function (condition) {
      if (!state.fields[condition.field]) return;
      var parentId = state.fields[condition.field].parentId;
      if (parentId === field.parentId) condition.field = condition.field + "_".concat(value);
    }); // save visibility conditions for current field

    state.visibility.conditions[fieldId] = visibilityConditions; // calculate a map of visibility dependencies between fields

    visibilityConditions.forEach(function (condition) {
      if (!state.visibility.mapping[condition.field]) state.visibility.mapping[condition.field] = []; // already a mapping between fields

      if (state.visibility.mapping[condition.field].includes(fieldId)) return; // current's field visibility depends on the field from condition

      state.visibility.mapping[condition.field].push(fieldId);
    });
  } catch (error) {}
};

export default {
  removeVisibility: removeVisibility,
  readVisibility: readVisibility
};